import React from "react";
import * as XLSX from "xlsx";
import "./utils.css";

const ExportToExcel = ({ data }) => {
  console.log(data, "excel data");
  const date = new Date();

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${day}-${month}-${year}`;

  const exportToExcel = () => {
    const wb = XLSX.utils.book_new();

    // ---------------- Customers Sheet ----------------
    const customers = data.customer.map((customer) => {
      const base = {
        Name: customer.name,
        "Phone Number": customer.phoneNumber,
        "Meeting With": customer.meetingWith,
        "Place of Visit": customer.placeOfVisit,
        "CP Enrolled": customer.cpEnrolled,
        Requirement: customer.requirement,
        Budget: customer.budget,
        "Arrived On": customer.createdAt.substring(0, 10),
        "Visit Count": customer.visitCount,
      };

      // Add Visits dynamically (Visit 1, Visit 2, ...)
      if (customer.visits && customer.visits.length > 0) {
        customer.visits.forEach((visit, idx) => {
          base[`Visit ${idx + 1}`] = visit;
        });
      }

      // Add Images dynamically (Image 1, Image 2, ...)
      if (customer.imagesUrls && customer.imagesUrls.length > 0) {
        customer.imagesUrls.forEach((url, idx) => {
          base[`Image ${idx + 1}`] = url;
        });
      }

      return base;
    });

    const customersSheet = XLSX.utils.json_to_sheet(customers);
    XLSX.utils.book_append_sheet(wb, customersSheet, "Customers");

    // ---------------- Multiple Visits Sheet ----------------
    const multipleVisit = data.customer
      .filter((item) => item.visitCount > 1)
      .map((customer) => {
        const base = {
          Name: customer.name,
          "Phone Number": customer.phoneNumber,
          "Meeting With": customer.meetingWith,
          "Place of Visit": customer.placeOfVisit,
          "CP Enrolled": customer.cpEnrolled,
          Requirement: customer.requirement,
          Budget: customer.budget,
          "Arrived On": customer.createdAt.substring(0, 10),
          "Visit Count": customer.visitCount,
        };

        // Visits
        if (customer.visits && customer.visits.length > 0) {
          customer.visits.forEach((visit, idx) => {
            base[`Visit ${idx + 1}`] = visit;
          });
        } else {
          base["Visits"] = "No Visits";
        }

        // Images
        if (customer.imagesUrls && customer.imagesUrls.length > 0) {
          customer.imagesUrls.forEach((url, idx) => {
            base[`Image ${idx + 1}`] = url;
          });
        } else {
          base["Images"] = "No Images";
        }

        return base;
      });

    const multipleVisitsSheet = XLSX.utils.json_to_sheet(multipleVisit);
    XLSX.utils.book_append_sheet(wb, multipleVisitsSheet, "Multiple Visits");

    // ---------------- Channel Partners Sheet ----------------
    const channelPartners = data.channelPartner.map((partner) => ({
      Name: partner.name,
      "Phone Number": partner.phoneNumber,
      "Company Name": partner.companyName,
      "Meeting With": partner.meetingWith,
      "Place of Visit": partner.placeOfVisit,
      "Arrived On": partner.createdAt.substring(0, 10),
    }));

    const channelPartnersSheet = XLSX.utils.json_to_sheet(channelPartners);
    XLSX.utils.book_append_sheet(wb, channelPartnersSheet, "Channel Partners");

    // ---------------- Save File ----------------
    XLSX.writeFile(wb, `Site Registeration Data ${currentDate}.xlsx`);
  };

  return (
    <div>
      <button className="jsonToExcelBtn" onClick={exportToExcel}>
        Export to Excel
      </button>
    </div>
  );
};

export default ExportToExcel;
